import jwtDecode from 'jwt-decode';

export const setToken = (token) => localStorage.setItem('token', token);

export const getToken = () => localStorage.getItem('token');

export const getTokenDecoded = () => {
    if (getToken()) {
        return jwtDecode(getToken());
    }
    return null;
};

export const removeToken = () => localStorage.removeItem('token');

export const isTokenExpired = () => {
    try {
        const decoded = getTokenDecoded();
        if (!decoded) {
            return true;
        }

        // Check if the exp claim exists and if the token is expired
        const currentTime = new Date().getTime() / 1000;
        return !decoded.exp || decoded.exp < currentTime;
    } catch (error) {
        // If there's an error decoding the token, consider it expired
        return true;
    }
};

export const validateToken = () => {
    if (!getToken()) {
        return false;
    }

    if (isTokenExpired()) {
        // If token is expired, remove it and return false
        removeToken();
        return false;
    }

    return true;
};
